const cx = (...names: (string | false | undefined)[]): string => names.filter(Boolean).join(' ');

export function Skeleton({ className }: { className?: string }): JSX.Element {
  return (
    <div
      className={cx('animate-pulse rounded-md bg-zinc-200/70 dark:bg-zinc-800/60', className)}
      aria-hidden="true"
    />
  );
}

/** Placeholder matching `StatTile`'s shape — label bar, big value bar, hint bar. */
export function SkeletonStatTile(): JSX.Element {
  return (
    <div className="rounded-[32px] p-6 md:p-8 border border-zinc-100 dark:border-white/5 bg-white dark:bg-zinc-900/50 flex flex-col gap-4 h-full">
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="w-10 h-10 rounded-full shrink-0" />
      </div>
      <Skeleton className="h-8 w-16" />
      <Skeleton className="h-3 w-32 mt-auto" />
    </div>
  );
}

/** Placeholder matching `TimelineRow`/`Table` row shape — icon circle + two text bars + trailing bar. */
export function SkeletonRow(): JSX.Element {
  return (
    <div className="flex items-center gap-4 p-5 bg-zinc-50 dark:bg-zinc-900/40 border border-zinc-100 dark:border-white/5 rounded-2xl">
      <Skeleton className="w-10 h-10 rounded-full shrink-0" />
      <div className="flex-1 flex flex-col gap-2">
        <Skeleton className="h-3.5 w-1/3" />
        <Skeleton className="h-3 w-1/4" />
      </div>
      <Skeleton className="h-3 w-16 shrink-0" />
    </div>
  );
}
